import React from 'react';

const TopBar = () => {
  return (
    <div className="bg-gradient-to-r from-gray-900 to-black text-amber-500 text-[14px] font-bold uppercase tracking-widest py-2 border-b border-gray-800">
      <style>{`
        @keyframes scroll-marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .marquee {
          overflow: hidden;
        }
        
        .marquee-content {
          display: flex;
          align-items: center;
          animation: scroll-marquee 120s linear infinite;
          will-change: transform;
        }
        
        .marquee:hover .marquee-content {
          animation-play-state: paused !important;
        }
      `}</style>
      <div className="max-w-7xl mx-auto text-center overflow-hidden whitespace-nowrap">

        {/* Mobile Scrolling Marquee */}
        <div className="marquee md:hidden">
          <div className="marquee-content">
            <span className="mx-4">&nbsp; &emsp; &ensp; &nbsp;</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">GARUD STACKS PVT LTD</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">20+ ACTIVE CLIENTS</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">15+ PROJECTS DELIVERED</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">6+ MONTHS PROVEN EXPERIENCE</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">SPEED • QUALITY • CUSTOMIZATION</span>
            <span className="mx-4">&nbsp; &emsp; &ensp; &nbsp;</span>
            <span className="mx-4">GARUD STACKS PVT LTD</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">20+ ACTIVE CLIENTS</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">15+ PROJECTS DELIVERED</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">6+ MONTHS PROVEN EXPERIENCE</span>
            <span className="mx-4 text-gray-500">•</span>
            <span className="mx-4">SPEED • QUALITY • CUSTOMIZATION</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TopBar;
